"use client";

import { useCallback } from "react";

import { MUTE_TRADING_SOUNDS_KEY } from "@/constants";

import { useLocalStorage } from "./storage";

export function useTradingSound() {
  const [isMuted, setIsMuted] = useLocalStorage<boolean>(MUTE_TRADING_SOUNDS_KEY, false);

  const playTradingSound = useCallback(() => {
    if (isMuted) return;
    const audio = new Audio("/sounds/sound-of-trading.mp3");
    audio.play().catch(() => {
      // Silently ignore autoplay restrictions
    });
  }, [isMuted]);

  return { isMuted, setIsMuted, playTradingSound };
}
